const GlossarioSchema = () => ({
  title: 'AgSUS Glossário de siglas',
  fieldsets: [
    {
      id: 'default',
      title: 'Glossário',
      fields: [
        'forma',
        'etiqueta',
        'contagem',
        'titulo',
        'nivel',
        'subtitulo',
        'aberto',
        'itens',
      ],
    },
  ],
  properties: {
    forma: {
      title: 'Forma',
      choices: [
        ['completo', 'Completo: busca e índice das letras'],
        ['compacto', 'Siglas desta página: lista recolhível, no fim da página'],
      ],
      default: 'completo',
      noValueOption: false,
    },
    etiqueta: {
      title: 'Etiqueta',
      description:
        'Texto curto em caixa alta, só na forma completa. Ex.: Siglas',
      default: 'Siglas',
    },
    contagem: {
      title: 'Mostrar o número de siglas',
      type: 'boolean',
      default: true,
    },
    titulo: {
      title: 'Título',
      description:
        'Na forma recolhível, se ficar vazio, aparece "Siglas desta página".',
    },
    nivel: {
      title: 'Nível do título',
      choices: [
        ['h2', 'Intertítulo (H2)'],
        ['h3', 'Subtítulo (H3)'],
      ],
      default: 'h2',
      noValueOption: false,
    },
    subtitulo: { title: 'Texto sob o título', widget: 'textarea' },
    aberto: {
      title: 'Começa aberta',
      description: 'Só na forma recolhível.',
      type: 'boolean',
      default: false,
    },
    itens: {
      title: 'Siglas',
      description:
        'A ordem alfabética é automática. Para muitas siglas, use "Colar a lista" no próprio bloco.',
      widget: 'object_list',
      schema: {
        title: 'Sigla',
        fieldsets: [
          {
            id: 'default',
            title: 'Default',
            fields: ['sigla', 'significado', 'vinculo'],
          },
        ],
        properties: {
          sigla: { title: 'Sigla' },
          significado: {
            title: 'Significado',
            description: 'Por extenso, como no documento oficial.',
          },
          vinculo: {
            title: 'A que pertence',
            description:
              'Opcional. Ex.: Unidade de Gestão de Pessoas (UGP), Diretoria de Operações',
          },
        },
        required: [],
      },
    },
  },
  required: [],
});

export default GlossarioSchema;
